import { meta, MetaTag } from '@gig/magic-frontend-toolkit/src/services/meta';

const OG_LOCALE = 'og:locale';

export function formatOpenGraphLocale(locale: string): string {
    const [language, ...subtags] = locale.split(/[-_]/);

    return [
        language.toLowerCase(),
        ...subtags.map((subtag, index) =>
            index === subtags.length - 1 ? subtag.toUpperCase() : subtag,
        ),
    ].join('_');
}

export function syncOpenGraphMetaTags() {
    const description = document.querySelector<HTMLMetaElement>(
        "meta[name='description']",
    );
    const canonical = document.querySelector<HTMLLinkElement>(
        "link[rel='canonical']",
    );

    meta.setMetaTag({
        name: MetaTag.OG_TITLE,
        content: document.title,
    });
    meta.setMetaTag({
        name: MetaTag.OG_DESCRIPTION,
        content: description?.content || '',
    });
    meta.setMetaTag({
        name: MetaTag.OG_URL,
        content: canonical?.href || window.location.href,
    });
    meta.setMetaTag({
        name: OG_LOCALE,
        content: formatOpenGraphLocale(document.documentElement.lang),
    });
}
